function CheckBox({ value, handChange, disabled = false }) {
    return (
        <div
            className={`check-box-icon ${value ? 'checked' : ''}`}
            onClick={() => handChange(!value)}
            style={{ cursor: disabled ? 'no-drop' : 'pointer' }}
        ></div>
    );
}

export default CheckBox;
